import { useNavigate } from "react-router-dom";
import { Lock, Map, ArrowRight, X, Sparkles } from "lucide-react";

export const MarketplaceUnlockModal = ({ open, onClose, pct = 0 }) => {
  const navigate = useNavigate();
  if (!open) return null;
  const go = () => { onClose(); navigate("/ai-resources/roadmap"); };
  return (
    <div className="fixed inset-0 z-[130] bg-black/55 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose} data-testid="marketplace-unlock-modal">
      <div className="bg-white rounded-3xl w-full max-w-sm p-7 shadow-2xl text-center relative" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute top-4 right-4 text-[#9aa1ab] hover:text-[#0F0F0F]" data-testid="marketplace-unlock-close"><X size={18} /></button>
        <div className="mx-auto w-14 h-14 rounded-2xl bg-gradient-to-br from-[#D4AF37] to-[#b8901f] text-[#0F0F0F] flex items-center justify-center shadow-lg">
          <Lock size={24} />
        </div>
        <h3 className="font-display text-xl font-extrabold text-[#0F0F0F] mt-4">Unlock This Feature</h3>
        <p className="text-sm text-[#687280] mt-2">Unlock the Ready-to-Build Startup marketplace by completing your <span className="font-semibold text-[#0F0F0F]">Founder Success Roadmap</span>.</p>

        <div className="mt-5 text-left">
          <div className="flex items-center justify-between text-xs font-semibold text-[#374151] mb-1.5">
            <span className="flex items-center gap-1.5"><Map size={13} className="text-[#D4AF37]" /> Roadmap progress</span>
            <span className="text-[#8a6d1a]">{pct}%</span>
          </div>
          <div className="h-2.5 rounded-full bg-gray-100 overflow-hidden">
            <div className="h-full rounded-full bg-gradient-to-r from-[#D4AF37] to-[#b8901f] transition-all duration-700" style={{ width: `${pct}%` }} />
          </div>
        </div>

        <button onClick={go} className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-[#0F0F0F] text-white rounded-full py-3 text-sm font-bold hover:bg-[#1c1c1c] transition-colors" data-testid="marketplace-unlock-cta">
          <Sparkles size={15} className="text-[#D4AF37]" /> Continue Your Roadmap <ArrowRight size={15} />
        </button>
        <p className="text-[11px] text-[#9aa1ab] mt-3">Complete all 10 stages to unlock the marketplace.</p>
      </div>
    </div>
  );
};
